export const GOOGLE_MAP_SCRIPT_ID = 'google-map-script'

export const GOOGLE_MAP_LIBRARIES: ('places')[] = ['places']
